import React, { useEffect, useState } from 'react';
import ImageUpload from '../../../../shared/image-upload/ImageUpload';

const ActivityCalendarImages = ({ initialValue, handleOnChange, onLoadingChange }) => {
  const [rawImages, setRawImages] = useState([]);
  const [status, setSatus] = useState(false);

  useEffect(() => {
    onLoadingChange?.(status);
  }, [status]);

  const onImageListUpdated = (imgObjArr) => {
    const createImageArray = [];
    imgObjArr?.forEach((img, index) => {
      if (img?.master || img?.isTouched) {
        createImageArray.push(img);
      } else {
        let currentImag = initialValue?.images?.value[index];
        createImageArray.push(currentImag);
      }
    });
    if (imgObjArr?.length) {
      setRawImages(createImageArray);
    } else if (rawImages.length) {
      handleOnChange({
        images: {
          ...initialValue.images,
          value: imgObjArr,
        },
      });
      setRawImages(imgObjArr);
    }
  };
  const onUploadedImageRemoval = (index) => {
    const images = [...initialValue.images.value];
    images.splice(index, 1);
    setRawImages([...images]);
  };
  useEffect(() => {
    if (rawImages.length) {
      handleOnChange({
        images: {
          ...initialValue.images,
          value: rawImages,
        },
      });
    }
  }, [rawImages]);

  return (
    <>
      <div className='row px-3 w-100 d-flex mt-4'>
        <ImageUpload
          uploadedImages={initialValue?.images?.value}
          imgList={rawImages}
          onImageListUpdated={onImageListUpdated}
          onUploadedImageRemoval={onUploadedImageRemoval}
          onImagesLoading={(status) => {
            setSatus(status);
          }}
          enabledMediaTabs={['image']}
        />
      </div>
    </>
  );
};

export default ActivityCalendarImages;
